<template lang="html">
<div class="error-container">
  ERROR HAS OCCURED

  This will become a sexy 404 page eventually
</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
</style>




// WEBPACK FOOTER //
// src/pages/Error.vue